import template, { item as itemTemplate } from './templates/order-history-line';
import { context as defaultContext } from './order-history-defaults';

/**
 * @typedef {Object} LineData
 * @property {string} date
 * @property {Array<string>} items
 * @property {string} link
 * @property {string} orderNumber
 * @property {string} total
 * @property {string} status
 */

export default class OrderHistoryLine {
    /**
     * 
     * @param {JQuery?} $rootEl 
     * @param {LineData} data 
     * @param {Object<string,any>} context 
     */
    constructor($rootEl, data, context) {
        context = { ...defaultContext, ...context };

        const $parsed = $($.parseHTML(template));
        this.$el = $parsed;
        this.$rootEl = $rootEl?.length ? $rootEl : null;

        this.$dateLabel = this.$el.find('[data-label="date"]');
        this.$itemsLabel = this.$el.find('[data-label="items"]');
        this.$orderNumberLabel = this.$el.find('[data-label="orderNumber"]');
        this.$totalLabel = this.$el.find('[data-label="total"]');

        this.$date = this.$el.find('[data-region="date"]');
        this.$items = this.$el.find('[data-region="items"]');
        this.$link = this.$el.find('[data-region="link"]');
        this.$orderNumber = this.$el.find('[data-region="orderNumber"]');
        this.$status = this.$el.find('[data-region="status"]');
        this.$total = this.$el.find('[data-region="total"]');

        this.data = data;
        this.context = context;

        this.init();
    }

    init() {
        this.renderLabels();
        this.renderData();
    }

    render() {
        this.$rootEl?.html(this.$el);
        return this.$el;
    }

    renderLabels() {
        this.$dateLabel.html(this.context.OrderPlaced);
        this.$itemsLabel.html(this.context.ItemsInOrder?.replace('{0}', this.data.items?.length) || '');
        this.$orderNumberLabel.html(this.context.OrderNumber);
        this.$totalLabel.html(this.context.OrderTotal);
    }

    renderData() {
        this.$date.html(this.data.date);
        this.$orderNumber.html(this.data.orderNumber || this.context.OrderNumberPending);
        this.$total.html(this.data.total);

        this.renderItems();
        this.renderLink();
        this.renderStatus();
    }

    renderItems() {
        const fragment = document.createDocumentFragment();

        this.data.items.forEach((name) => {
            const itemHtmlStr = itemTemplate(name);
            const [ itemNode ] = $.parseHTML(itemHtmlStr);
            fragment.appendChild(itemNode);
        });

        this.$items.html(fragment);
    }

    renderLink() {
        if(this.$link.is('a')) {
            this.$link.attr('href', this.data.link);
        }
    }

    renderStatus() {
        let status = this.data.status;
        const config = this.context.StatusOptions?.find((option) => option.Text === this.data.status);

        if(config) {
            status = config.Text;
            this.$status.addClass(config.Class);
        }

        this.$status.html(status);
    }
}
